import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Trip } from '../data-models/trip-models/trip.model';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor() {

  }

  // check if the date is defined
  public static validateDate(date: any): Date {
    
    return new Date(date ?? new Date());

  }

  // check if homepage is defined
  public static validateHomepage(homepage: string | null): string {

    if (!homepage) {
      return ValidationService.setHomepage();
    }
    return homepage;

  }

  // set the sign up page to a new user
  public static setHomepage(): string {

    return 'sign-up';

  }

  // Credit to Zahema for this match validator https://stackoverflow.com/a/55929868

  public static match(controlName: string, matchControlName: string): ValidatorFn {
    return (controls: AbstractControl) => {
      const control: AbstractControl<any, any> | null = controls.get(controlName);
      const matchControl: AbstractControl<any, any > | null = controls.get(matchControlName);

      if (!matchControl?.errors && control?.value !== matchControl?.value) {
        matchControl?.setErrors({
          matching: {
            actualValue: matchControl?.value,
            requiredValue: control?.value
          }
        });
        return { matching: true };
      }
      return null;
    };
  }

// A validator factory function. We pass in the Trip so the validator
// can check mgmtArea against trip.startFishingReport.managementArea.
public static mgmtAreaMustMatchTrip(trip: Trip): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const chosenArea = String(control.value.name ?? '').replace('Area ', '');
    const startArea = String(trip.startFishingReport.managementArea?.name ?? '');
    return chosenArea === startArea ? null : { mgmtAreaMismatch: true };
  };
}

  

}
